export default {

  data() {
    return {
      options: [
        { key: 'Webportal.Porsche.Unacceptable', numbers: '0-34%'},
        { key: 'Webportal.Porsche.Insufficient', numbers: '35-59%'},
        { key: 'Webportal.Porsche.ToBeOptimized', numbers: '60-74%'},
        { key: 'Webportal.Porsche.Good', numbers: '75-90%'},
        { key: 'Webportal.Porsche.Excellent', numbers: '91-100%'}
      ]
    };
  },

  methods: {
    tooltipText(index) {
      return this.options[index].numbers  + ' ' + this.$t(this.options[index].key);
    },

    displayTextConditional(index) {
      if (this.showText) {
        return this.options[index].numbers;
      }
    },

    displayText(index) {
      return this.options[index].numbers;
    }
  }
};
